export const languageNames: Record<string, string> = {
	uk: 'Українська',
	ru: 'Русский',
	en: 'English',
	de: 'Deutsch',
	pl: 'Polski',
};

export const alpha2ToAlpha3LanguageCode: Record<string, string> = {
	uk: 'ukr',
	ru: 'rus',
	en: 'eng',
	de: 'deu',
	pl: 'pol',
};

// Mirrored value to alpha3ToAlpha2LanguageCode
export const alpha3ToAlpha2LanguageCode = Object.entries(alpha2ToAlpha3LanguageCode).reduce<Record<string, string>>(
	(map, [alpha2, alpha3]) => ({...map, [alpha3]: alpha2}),
	{},
);
